import React, { useEffect, useState } from 'react'
import { ProductItem } from '@components/common/ProductTile/ProductTile'
import { ProductItemMobile } from '@components/common/ProductTileMobile/ProductTileMobile'
import { SimpleProduct, ConfigurableProduct } from '@pylot-data/pylotschema'
import { isMobileScreen } from '@lib/utils/mediaQuery'

type Props = {
    product: SimpleProduct | ConfigurableProduct
}

const WrappedFBTProductItem = React.memo(function WrappedFBTProductItem({
    product
}: Props): JSX.Element | null {
    const [isMobile, setIsMobile] = useState<boolean | null>(null)

    useEffect(() => {
        setIsMobile(isMobileScreen())
    }, [])

    if (isMobile === null) return null

    return isMobile ? (
        <div>
            <ProductItemMobile product={product} imageParam={{ width: 100 }} />
        </div>
    ) : (
        <div>
            <ProductItem product={product} isPDP imageParam={{ width: 500 }} />
        </div>
    )
})

WrappedFBTProductItem.displayName = 'WrappedFBTProductItem'

export default WrappedFBTProductItem
